// router/index.js
import {
	createRouter,
	createWebHashHistory,
	createWebHistory
} from 'vue-router'
import { Capacitor } from '@capacitor/core'
import { ChatPlugin } from '@/integrations/chat'
import { useAuthManager } from '@/state/user'
import { isSocialEnabled } from '@/interfaces/appVersion'

const routes = [
	{
		path: '/splash',
		component: () => import('@/pages/Splash.vue'),
		meta: {
			title: '启动页',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/',
		component: () => import('@/pages/Top.vue'),
		meta: {
			title: '推荐',
			requiresAuth: false,
			showTabBar: true
		}
	},
	{
		path: '/service',
		component: () => import('@/pages/Service.vue'),
		meta: {
			title: '服务套餐',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/service/city-vote',
		component: () => import('@/pages/service/CityVote.vue'),
		meta: {
			title: '城市投票',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/specialists',
		component: () => import('@/pages/Tech.vue'),
		meta: {
			title: '助理列表',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/conversations',
		component: () => import('@/pages/chat/List.vue'),
		meta: {
			title: '聊天会话',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/conversation-detail',
		component: () => import('@/pages/chat/Message.vue'),
		meta: {
			title: '聊天消息',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		name: 'SpecialistDetail',
		path: '/specialist-detail',
		component: () => import('@/pages/tech/TechDetail.vue'),
		meta: {
			title: '助理详情',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		name: 'MerchantDetail',
		path: '/merchant-detail',
		component: () => import('@/pages/merchant/MerchantDetail.vue'),
		meta: {
			title: '商家详情',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		name: 'SpecialistPortfolio',
		path: '/specialist-portfolio',
		component: () => import('@/pages/tech/TechPortfolio.vue'),
		meta: {
			title: '个人作品主页',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		name: 'SpecialistReview',
		path: '/specialist-review',
		component: () => import('@/pages/tech/Review.vue'),
		meta: {
			title: '评价助理',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		name: 'SpecialistReviews',
		path: '/specialist-reviews',
		component: () => import('@/pages/tech/Reviews.vue'),
		meta: {
			title: '助理评价',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/video',
		component: () => import('@/pages/Video.vue'),
		meta: {
			title: '视频',
			requiresAuth: false,
			showTabBar: true
		}
	},
	{
		path: '/messages/center',
		component: () => import('@/pages/message/Center.vue'),
		meta: {
			title: '消息中心',
			requiresAuth: true,
			showTabBar: true
		}
	},
	{
		path: '/messages/list',
		component: () => import('@/pages/message/List.vue'),
		meta: {
			title: '消息列表',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/recommended',
		component: () => import('@/pages/Top.vue'),
		meta: {
			title: '推荐',
			requiresAuth: false,
			showTabBar: true
		}
	},
	{
		path: '/portfolio/detail',
		component: () => import('@/pages/portfolio/PortfolioDetail.vue'),
		meta: {
			title: '动态详情',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/portfolio/topics',
		component: () => import('@/pages/portfolio/HotTopicList.vue'),
		meta: {
			title: '热门话题',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/profile',
		component: () => import('@/pages/My.vue'),
		meta: {
			title: '我的',
			requiresAuth: true,
			showTabBar: true
		}
	},
	{
		path: '/wellness',
		component: () => import('@/pages/Health.vue'),
		meta: {
			title: '春信',
			requiresAuth: false,
			showTabBar: true
		}
	},
	{
		name: 'WellnessNeck',
		path: '/wellness/neck-care',
		component: () => import('@/pages/health/MoxaNeck.vue'),
		meta: {
			title: '肩颈调理艾灸',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		name: 'WellnessSpleen',
		path: '/wellness/spleen-care',
		component: () => import('@/pages/health/MoxaSpleen.vue'),
		meta: {
			title: '脾胃调理艾灸',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		name: 'WellnessQi',
		path: '/wellness/energy-care',
		component: () => import('@/pages/health/MoxaQi.vue'),
		meta: {
			title: '气血调理艾灸',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/packages/detail',
		component: () => import('@/pages/service/PackageDetail.vue'),
		meta: {
			title: '套餐详情',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/profile/settings',
		component: () => import('@/pages/my/Setting.vue'),
		meta: {
			title: '设置',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/profile/recharge',
		component: () => import('@/pages/my/Recharge.vue'),
		meta: {
			title: '充值',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/profile/recharge-history',
		component: () => import('@/pages/my/RechargeHistory.vue'),
		meta: {
			title: '充值记录',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/profile/tip-history',
		component: () => import('@/pages/my/TipHistory.vue'),
		meta: {
			title: '打赏记录',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/profile/personal',
		component: () => import('@/pages/my/Personal.vue'),
		meta: {
			title: '个人信息',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/profile/edit-mobile',
		component: () => import('@/pages/my/EditMobile.vue'),
		meta: {
			title: '修改手机号',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		name: 'OrderList',
		path: '/order/list',
		component: () => import('@/pages/order/OrderList.vue'),
		meta: {
			title: '订单',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/order/detail',
		component: () => import('@/pages/order/OrderDetail.vue'),
		meta: {
			title: '订单详情',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		name: 'OrderBooking',
		path: '/booking/create-booking',
		component: () => import('@/pages/order/OrderBooking.vue'),
		meta: {
			title: '预约下单',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		name: 'OrderExtend',
		path: '/booking/extend-booking',
		component: () => import('@/pages/order/OrderExtend.vue'),
		meta: {
			title: '订单加钟',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		name: 'AddressList',
		path: '/address/list',
		component: () => import('@/pages/address/AddressList.vue'),
		meta: {
			title: '地址列表',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		name: 'AddressSave',
		path: '/address/save',
		component: () => import('@/pages/address/AddressSave.vue'),
		meta: {
			title: '地址保存',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		name: 'Story',
		path: '/core/story',
		component: () => import('@/pages/core/Story.vue'),
		meta: {
			title: '我们的故事',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		name: 'Academy',
		path: '/core/academy',
		component: () => import('@/pages/core/Academy.vue'),
		meta: {
			title: '香学院',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		name: 'Formula',
		path: '/core/formula',
		component: () => import('@/pages/core/Formula.vue'),
		meta: {
			title: '配方',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		name: 'Product',
		path: '/core/product',
		component: () => import('@/pages/core/Product.vue'),
		meta: {
			title: '产品',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/login',
		component: () => import('@/pages/Login.vue'),
		meta: {
			title: '登录',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/mobile-login',
		component: () => import('@/pages/MobileLogin.vue'),
		meta: {
			title: '手机号登录',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/login-callback',
		component: () => import('@/pages/callback/LoginCallback.vue'),
		meta: {
			title: '登录中',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/account-error',
		component: () => import('@/pages/AccountError.vue'),
		meta: {
			title: '帐号异常',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/location/select',
		name: 'SelectLocation',
		component: () => import('@/pages/location/SelectLocation.vue'),
		meta: {
			title: '选择位置',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/location/city-selection',
		name: 'CitySelection',
		component: () => import('@/pages/location/CitySelection.vue'),
		meta: {
			title: '选择城市',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/map-distance',
		name: 'MapDistance',
		component: () => import('@/pages/location/Distance.vue'),
		meta: {
			title: '地图',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/profile/preference',
		component: () => import('@/pages/my/Preference.vue'),
		meta: {
			title: '偏好设置',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/profile/favorites',
		component: () => import('@/pages/my/Favorites.vue'),
		meta: {
			title: '关注列表',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/profile/coupon-list',
		component: () => import('@/pages/my/CouponList.vue'),
		meta: {
			title: '我的优惠券',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/cities',
		component: () => import('@/pages/CityList.vue'),
		meta: {
			title: '已开通城市',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/profile/feedback',
		component: () => import('@/pages/my/Feedback.vue'),
		meta: {
			title: '用户反馈',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/profile/feedback-history',
		component: () => import('@/pages/my/FeedbackHistory.vue'),
		meta: {
			title: '反馈记录',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/profile/feedback-detail',
		component: () => import('@/pages/my/FeedbackDetail.vue'),
		meta: {
			title: '反馈详情',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/after-sale/apply',
		name: 'AfterSaleApply',
		component: () => import('@/pages/after-sale/Apply.vue'),
		meta: {
			title: '申请售后',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/after-sale/detail',
		name: 'AfterSaleDetail',
		component: () => import('@/pages/after-sale/Detail.vue'),
		meta: {
			title: '售后详情',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/profile/after-sale',
		name: 'AfterSaleList',
		component: () => import('@/pages/my/AfterSale.vue'),
		meta: {
			title: '售后记录',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/profile/official-account',
		component: () => import('@/pages/my/OfficialAccount.vue'),
		meta: {
			title: '扫码关注',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/profile/invite-code',
		name: 'MyInviteCode',
		component: () => import('@/pages/my/MyInviteCode.vue'),
		meta: {
			title: '我的邀请码',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/profile/invite-detail',
		name: 'InviteDetail',
		component: () => import('@/pages/my/InviteDetail.vue'),
		meta: {
			title: '邀请明细',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/invite-share',
		name: 'InviteShare',
		component: () => import('@/pages/InviteShare.vue'),
		meta: {
			title: '邀请好友',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/invite',
		name: 'InviteRegister',
		component: () => import('@/pages/InviteRegister.vue'),
		meta: {
			title: '好友邀请',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/invite-technician',
		name: 'MerchantInviteRegister',
		component: () => import('@/pages/MerchantInviteRegister.vue'),
		meta: {
			title: '商家邀请',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/vip/purchase',
		component: () => import('@/pages/VipPurchase.vue'),
		meta: {
			title: '会员中心',
			requiresAuth: true,
			showTabBar: false
		}
	},
	{
		path: '/corp/index',
		component: () => import('@/pages/corp/Index.vue'),
		meta: {
			title: '关于',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/corp/policy',
		component: () => import('@/pages/corp/Policy.vue'),
		meta: {
			title: '隐私政策',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/corp/agreement',
		component: () => import('@/pages/corp/Agreement.vue'),
		meta: {
			title: '用户协议',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/corp/duty',
		component: () => import('@/pages/corp/Duty.vue'),
		meta: {
			title: '责任声明',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/corp/booking-notice',
		component: () => import('@/pages/corp/BookingNotice.vue'),
		meta: {
			title: '预约须知',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/corp/privacy-protection',
		component: () => import('@/pages/corp/PrivacyProtection.vue'),
		meta: {
			title: '号码保护说明',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/corp/about-us',
		component: () => import('@/pages/corp/AboutUs.vue'),
		meta: {
			title: '关于我们',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/rtc/test',
		component: () => import('@/pages/rtc/Test.vue'),
		meta: {
			title: 'RTC 语音测试',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/freelancer/apply',
		component: () => import('@/pages/freelancer/Apply.vue'),
		meta: {
			title: '助理合作意向登记',
			requiresAuth: false,
			showTabBar: false
		}
	},
	{
		path: '/freelancer/recruit',
		component: () => import('@/pages/freelancer/Recruit.vue'),
		meta: {
			title: '招聘合作',
			requiresAuth: false,
			showTabBar: false
		}
	},
]

const router = createRouter({
	//history: createWebHistory(), // 微信H5建议用hash模式，也不一定。
	history: createWebHashHistory(), // 改为Hash模式，URL会带#
	routes,
	scrollBehavior(to, from, savedPosition) {
		// 如果有保存的位置（比如浏览器后退），返回该位置
		if (savedPosition) {
			return savedPosition
		}

		// 默认滚动到顶部
		return { top: 0 }
	}
})

// 全局变量：记录登录后要跳转的目标页
let loginTargetPath = '';
// 登录流程的过渡页：从这些页返回登录页时不算"来时页面"，不覆盖 redirect
// （否则 登录页→看协议→返回→登录成功 会跳回协议页而不是来时的页面）
const LOGIN_AUX_PATHS = ['/corp/agreement', '/corp/policy', '/mobile-login', '/account-error', '/login-callback'];
// 标记是否已检查过启动页（避免重复检查）
let splashChecked = false;

/**
 * 判断是否需要显示启动页
 */
const shouldShowSplash = () => {
	console.log('🎨 [路由-启动页检查] 开始检查')

	// 如果已经检查过，不再重复检查
	if (splashChecked) {
		console.log('🎨 [路由-启动页检查] 已检查过，跳过')
		return false
	}

	// 测试模式：URL 带有 forceSplash=true 强制显示
	if (window.location.search.includes('forceSplash=true')) {
		console.log('🎨 [路由-启动页检查] 测试模式：强制显示')
		splashChecked = true
		return true
	}

	// 检查 URL 参数，如果带有 noSplash=true 则不显示
	if (window.location.search.includes('noSplash=true')) {
		console.log('🎨 [路由-启动页检查] URL 参数禁止显示')
		splashChecked = true
		return false
	}

	// 检查是否已经显示过启动页（本次会话）
	const sessionShown = sessionStorage.getItem('splash_shown')
	if (sessionShown) {
		console.log('🎨 [路由-启动页检查] 本次会话已显示过')
		splashChecked = true
		return false
	}

	// 检查今日是否已显示过
	const lastShown = localStorage.getItem('splash_last_shown')
	const today = new Date().toDateString()

	if (lastShown !== today) {
		localStorage.setItem('splash_last_shown', today)
		sessionStorage.setItem('splash_shown', 'true')
		console.log('🎨 [路由-启动页检查] 每日首次启动，显示启动页')
		splashChecked = true
		return true
	}

	console.log('🎨 [路由-启动页检查] 今日已显示过，跳过')
	splashChecked = true
	return false
}

// 动态设置标题
router.beforeEach(async (to, from, next) => {
	console.log('🧭 路由导航:', from.path, '->', to.path)
	console.log('🧭 目标组件:', to.matched.map(r => r.components?.default?.__name || r.path))
	document.title = to.meta.title + '-春信助理' || '春信助理'

	// 启动页检查：访问首页时检查是否需要显示启动页
	if (to.path === '/' && from.path === '/' && shouldShowSplash()) {
		console.log('🎨 [路由-启动页检查] 重定向到启动页')
		next('/splash')
		return
	}

	// 检查社交功能开关（Android 且 socialOn=false 时禁止访问与助理的聊天，但允许与客服沟通）
	const isAndroid = Capacitor.getPlatform() === 'android'
	if (isAndroid && !isSocialEnabled()) {
		const chatType = to.query.chatType
		const isCustomerServiceChat = chatType === '3' || chatType === 3 // 客服会话类型
		const socialRoutes = ['/conversations', '/conversation-detail']
		if (socialRoutes.includes(to.path) && !isCustomerServiceChat) {
			console.log('🔒 社交功能已关闭，禁止访问助理聊天页面:', to.path)
			next(false) // 中断导航
			return
		}
	}

	// iOS 设备访问聊天页面时，直接打开原生聊天
	const isIOS = Capacitor.getPlatform() === 'ios'
	// isAndroid 已在上面声明 (line 754)
	const isNativeApp = Capacitor.isNativePlatform()

	if ((isIOS || isAndroid) && isNativeApp && to.path === '/conversation-detail' && to.query.chatId) {
		try {
			const authManager = useAuthManager()
			const apiBaseUrl = import.meta.env.VITE_API_BASE_URL || 'https://api-cust.test.kenzom.com'
			const token = localStorage.getItem('token') || ''

			let userId = authManager.userId
			if (!userId) {
				userId = authManager.userProfile?.userId || authManager.userProfile?.id || ''
			}
			if (!userId) {
				userId = localStorage.getItem('userId') || ''
			}
			const targetUserId = to.query.targetUserId || ''
			const freelancerId = to.query.freelancerId || ''

			console.log('🚪 从聊天列表进入，打开原生聊天 - chatId:', to.query.chatId, '平台:', isIOS ? 'iOS' : 'Android')
			console.log('🚪 参数 - targetUserId:', targetUserId, 'freelancerId:', freelancerId)

			// Android 使用 technicianType 区分客户（2-客户）
			const technicianType = '2'

			ChatPlugin.openChat({
				chatId: to.query.chatId,
				chatName: to.query.chatName || '聊天',
				chatIcon: to.query.chatIcon || '',
				targetUserId: String(targetUserId),
				freelancerId: String(freelancerId),
				chatType: String(to.query.chatType || ''),
				apiBaseUrl: apiBaseUrl,
				token: token,
				userId: String(userId),
				technicianType
			})

			// 中断导航，不进入 H5 页面
			next(false)
			return
		} catch (error) {
			console.log('打开原生聊天失败，显示 H5 页面:', error)
		}
	}

	// 1. 跳转到登录页时，记录目标页（redirect参数）
	// 从登录流程过渡页（协议/隐私/验证码页等）返回登录页时不重新记录，
	// 最初记录的 redirect 仍在 history 的 query 里，登录后照常回到来时页面
	if (to.path === '/login' && from.path && from.path !== '/login'
		&& !LOGIN_AUX_PATHS.includes(from.path)) {
		// 特殊处理：从设置页退出登录时，重定向到"我的"页面而非设置页
		let redirectPath = from.path;
		if (from.path === '/profile/settings') {
			redirectPath = '/profile';
		}
		const queryString = Object.keys(from.query).length > 0
			? `?${new URLSearchParams(from.query).toString()}`
			: '';
		to.query.redirect = encodeURIComponent(redirectPath + queryString);
		// 存储目标页到全局变量
		loginTargetPath = redirectPath;
	}

	// 2. 登录成功后跳转到目标页时，标记该页面“来自登录”
	if (to.path === '/login-callback') {
		localStorage.setItem('fromLogin', true);// 标记：当前页面是登录后跳转而来
		// 清除记录，避免重复标记
		loginTargetPath = '';
	}

	next()
})

// 路由错误处理
router.onError((error) => {
	console.error('🚨 路由错误:', error)
	console.error('🚨 错误堆栈:', error.stack)
	console.error('🚨 当前位置:', window.location.href)
	console.error('🚨 当前模式:', import.meta.env.MODE, import.meta.env.DEV ? '开发' : '生产')

	// 显示用户友好的错误提示
	if (error.message.includes('Failed to fetch')) {
		console.error('🚨 动态导入失败 - 可能的原因:')
		console.error('  1. 构建输出未正确部署')
		console.error('  2. 服务器配置问题')
		console.error('  3. 网络连接问题')
		console.error('  4. 访问的是开发服务器而非生产构建')
	}
})

// 路由成功后
router.afterEach((to, from) => {
	console.log('✅ 路由导航成功:', from.path, '->', to.path)
})

export default router